import script from "./product-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./product-detail.vue?vue&type=script&setup=true&lang=js"

import "./product-detail.vue?vue&type=style&index=0&id=6fb15d44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb15d44"]])

export default __exports__